import { Box, Text, VStack, Flex, Grid, Skeleton } from "@chakra-ui/react";
import { FormValues } from "@/models/proposalForm.model";
import { FinancialInfo } from "@/models/proposal.model";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";

interface ProductStepProps {
  tableOptions?: FinancialInfo[];
  updateData: (values: Partial<FormValues["resultStep"]>) => void;
  goToNextStep: () => void;
}

const colors = ["primary", "secondary", "yellow.400", "gray.400", "orange.400"];

export default function Component({
  tableOptions,
  updateData,
  goToNextStep,
}: ProductStepProps) {
  const handleTableClick = (opt: FinancialInfo) => {
    updateData({ chosenFinancialOption: opt });
    goToNextStep();
  };

  return (
    <Box mt={{ base: "2rem", md: "5rem" }} px={{ base: "2rem", md: "8rem" }}>
      <Grid templateColumns={{ base: "1fr", md: "1fr 2fr" }} gap={6}>
        <Box
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          mt="4rem"
        >
          <Text
            fontSize={{ base: "3xl", md: "6xl" }}
            fontWeight="bold"
            color="secondary"
            textAlign={{ base: "center", md: "left" }}
            fontFamily="Lexend Deca"
          >
            Escolha sua Tabela
          </Text>
        </Box>
        <VStack spacing={4} align="stretch">
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align={{ base: "center", md: "flex-start" }}
            w="100%"
            mb={2}
          >
            <Text
              fontSize={{ base: "lg", md: "xl" }}
              fontFamily="Lexend Deca"
              color="gray.500"
              ml={6}
            >
              Tabela
            </Text>
            <Text
              fontSize={{ base: "lg", md: "xl" }}
              fontFamily="Lexend Deca"
              color="gray.500"
              textAlign="right"
              width="40%"
              mr={4}
            >
              Valor Liberado
            </Text>
          </Flex>
          {!tableOptions ? (
            <>
              <Skeleton height={{ base: "60px", md: "80px" }} />
              <Skeleton height={{ base: "60px", md: "80px" }} />
              <Skeleton height={{ base: "60px", md: "80px" }} />
              <Skeleton height={{ base: "60px", md: "80px" }} />
            </>
          ) : (
            tableOptions.map((option) => (
              <Flex
                key={option.Product?.name}
                justify="space-between"
                align="center"
                bg={colors[tableOptions.indexOf(option)]}
                p={3}
                borderRadius="md"
                cursor="pointer"
                boxShadow="0px 8px 15px rgba(0, 0, 0, 0.3)"
                transition="transform 0.2s, box-shadow 0.2s"
                _hover={{
                  transform: "translateY(-3px)",
                  boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.4)",
                }}
                onClick={() => handleTableClick(option)}
              >
                <Text
                  fontSize={{ base: "xl", md: "2xl" }}
                  fontWeight="bold"
                  color="white"
                  fontFamily="Lexend Deca"
                  ml={4}
                >
                  {option.Product?.name}
                </Text>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  fontWeight="bold"
                  color="white"
                  fontFamily="Lexend Deca"
                  textAlign="right"
                  width="40%"
                  mr={4}
                >
                  {BrlCurrencyFormatter(
                    option.issueAmount! -
                      option.issueAmount! * (option.tacInput! / 100) -
                      option.iof!
                  )}
                </Text>
              </Flex>
            ))
          )}
        </VStack>
      </Grid>
    </Box>
  );
}
